// import React, {useEffect} from 'react';

// const MapMarker = () =>{
//     const ref = React.useRef(null);
//     const [map, setMap] = React.useState();
//     useEffect(() => {
//         if (ref.current && !map) {
//           setMap(new window.google.maps.Map(ref.current, {}));
//         }
//       }, [ref, map]);

//   return (
//     <div ref={ref} />
//   )
// }

// export default MapMarker;

import React from "react";
import { compose, withProps } from "recompose";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";
import ApiKey from "../common/constant";
import bike from "../assets/images/sktr1.svg";
import car from "../assets/images/sktrFront1.svg";

const defaultMapOptions = {
  zoomControl: false,
  mapTypeControl: false,
  scaleControl: true,
  streetViewControl: false,
  rotateControl: true,
  fullscreenControl: false,
};

const MyMapComponent = compose(
  withProps({
    googleMapURL:
      "https://maps.googleapis.com/maps/api/js?key=" +
      ApiKey +
      "&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `400px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)((props) => {
  const markers = props.data.map((val) => {
    return (
      <Marker
        position={{ lat: val.location.latitude, lng: val.location.longitude }}
        icon={val.type === "Scooter" ? bike : car}
      />
    );
    // <Marker position={{ lat: -34.297, lng: 150.444 }} icon={car} />
    // <Marker position={{ lat: -34.397, lng: 150.344 }} icon={bike} />
    // <Marker position={{ lat: -34.257, lng: 150.500 }} icon={car}/>
  });
  return (
    <GoogleMap
      defaultZoom={10}
      defaultCenter={{ lat: -34.397, lng: 150.644 }}
      defaultOptions={defaultMapOptions}
    >
      {markers}
    </GoogleMap>
  );
});

// ReactDOM.render(<MyMapComponent isMarkerShown />, document.getElementById("root"));

export default MyMapComponent;
